export default __webpack_public_path__ + "static/media/NH07.8c7c78db.jpg";